import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Dialog from '@panneau/modal-dialog';

var propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.node,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  confirmButton: PropTypes.shape({
    label: PropTypes.string
  }),
  cancelButton: PropTypes.shape({
    label: PropTypes.string
  }),
  className: PropTypes.string,
  children: PropTypes.node
};
var defaultProps = {
  title: null,
  onConfirm: null,
  onClose: null,
  confirmButton: null,
  cancelButton: null,
  className: null,
  children: null
};
function ConfirmModal(_ref) {
  var id = _ref.id,
    title = _ref.title,
    onConfirm = _ref.onConfirm,
    onClose = _ref.onClose,
    confirmButton = _ref.confirmButton,
    cancelButton = _ref.cancelButton,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Dialog, {
    id: id,
    title: title,
    size: "lg",
    onClose: onClose,
    className: className,
    buttons: [_objectSpread({
      id: 'no',
      name: 'no',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "yhU8J6",
        defaultMessage: [{
          "type": 0,
          "value": "No"
        }]
      }),
      theme: 'secondary',
      onClick: onClose
    }, cancelButton), _objectSpread({
      id: 'yes',
      name: 'yes',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "3ebjtX",
        defaultMessage: [{
          "type": 0,
          "value": "Yes"
        }]
      }),
      theme: 'primary',
      onClick: onConfirm
    }, confirmButton)]
  }, children);
}
ConfirmModal.propTypes = propTypes;
ConfirmModal.defaultProps = defaultProps;

export { ConfirmModal as default };
